module.exports = __webpack_public_path__ + "static/media/12.29a572be.svg";